import { configureStore } from '@reduxjs/toolkit';

import { setupListeners } from '@reduxjs/toolkit/query';
import { rivermeadowApi } from './api';

export const store = configureStore({
    reducer: {
        [rivermeadowApi.reducerPath]: rivermeadowApi.reducer,
    },

    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(rivermeadowApi.middleware),
});

setupListeners(store.dispatch);
